import { Component, OnInit, } from '@angular/core';

// Redux
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../../../core/store/store';

@Component({
  selector: 'app-maengelliste',
  templateUrl: './maengel-cont.component.html',
  styles: [`.thisCont {margin-top: 6.8rem}`]        // consider top menu
})
export class MaengelContComponent implements OnInit {

   // Stock feature
   @select((s: IAppState) => s.mangelState.maengel) _maengelListe$;

   constructor() { }

   ngOnInit() {
   }


}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/maengel/compc/maengel-cont/maengel-cont.component.ts